// extracted by mini-css-extract-plugin
export default {"aside-container":"UserPossibilities_aside-container__juxdF","options":"UserPossibilities_options__WSCUo","option":"UserPossibilities_option__A7TEC"};